<template>
  <div class="page-content cinema">
    <h1 class="page-title">{{ $locale("sideMenu.settings.cinemaManagement") }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="20">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-input :placeholder="$locale('theatre.plsEnterTheatreName')" v-model="filter.name">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-select v-model="filter.region" @change="regionChange" :placeholder="$locale('setting.emergency.area')">
              <el-option
                v-for="obj in regionOptions"
                :key="obj.val"
                :value="obj.val"
                :label="obj.text"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select v-model="filter.prefecture" :placeholder="$locale('setting.emergency.perfecture')">
              <el-option
                v-for="obj in prefectureOptions"
                :key="obj.val"
                :value="obj.val"
                :label="obj.text"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.search") }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" class="ta-r">
        <el-button v-if="accountType !== 'cinema'" class="egl-btn-yellow right-align-btn" @click="toDetail_fn('create')">{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" class="egl-table">
      <el-table-column prop="name" :label="$locale('global.cinemaName')" min-width="200"></el-table-column>
      <el-table-column prop="address1" :label="$locale('global.streetAddress')+'1'" min-width="200"></el-table-column>
      <el-table-column prop="address2" :label="$locale('global.streetAddress')+'2'" min-width="200"></el-table-column>
      <el-table-column prop="regionText" :label="$locale('setting.emergency.area')" min-width="100"></el-table-column>
      <el-table-column prop="prefectureText" :label="$locale('setting.emergency.perfecture')" min-width="100"></el-table-column>
      <el-table-column prop="city" :label="$locale('setting.cinema.city')" min-width="100"></el-table-column>
      <el-table-column align="center" width="240">
        <template slot="header">{{ $locale("global.control") }}</template>
        <template slot-scope="scope">
          <div class="handle">
            <a @click="toDetail_fn('edit', scope.row.id)"> {{ $locale("global.edit") }} </a>
            <template v-if="accountType === 'superAdmin' || isExistLoginAsAccountId">
              <el-divider direction="vertical"></el-divider>
              <a @click="delete_fn(scope.$index)"> {{ $locale("global.delete") }}</a>
            </template>
            <div v-if="accountType === 'brand'">
              <el-divider direction="vertical"></el-divider>
              <a @click="loginAs(scope.row.id)">{{ scope.row.name }} {{ $locale('setting.loginas')}} </a>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { localStorage } from "@/utils/localStorage";
import { getRegions, getCinemaList } from "@/helpers/service/api/common.js";
import { deleteCinema, loginAsCinema } from "@/helpers/service/api/cinema.js";
import { requestAll } from "@/helpers/service/axiosPlugin";
import countDownAlert from "@/utils/countDownAlert";
import CommPagination from "@/components/common/CommPagination";
import { setLocalStorage } from '@/assets/js/storage';
import "@/assets/style/cinema.less";

export default {
  name: "cinema",
  components: {
    CommPagination,
  },
  data() {
    return {
      onSearch: {
        name: "",
        region: "",
        prefecture: "",
        status: "active",
        page: 0,
        pageSize: 10,
      },
      filter: {
        name: "",
        region: "",
        prefecture: "",
      },
      pageCount: 0,
      tableData: [],
      regionOptions: [
        {
          text: this.$locale("region.Hokkaido"),
          prefecture: [
            { text: this.$locale("region.Hokkaido") }
          ],
        },
        {
          text: this.$locale("region.Northeast"),
          prefecture: [
            { text: this.$locale("perfecture.Aomori") },
            { text: this.$locale("perfecture.Iwate") },
            { text: this.$locale("perfecture.Miyagi") },
            { text: this.$locale("perfecture.Akita") },
            { text: this.$locale("perfecture.Yamagata") },
            { text: this.$locale("perfecture.Fukushima") }
          ],
        },
        {
          text: this.$locale("region.Kanto"),
          prefecture: [
            { text: this.$locale("prefecture.Ibaraki") },
            { text: this.$locale("prefecture.Tochigi") },
            { text: this.$locale("prefecture.Gunma") },
            { text: this.$locale("prefecture.Saitama") },
            { text: this.$locale("prefecture.Chiba") },
            { text: this.$locale("prefecture.Tokyo") },
            { text: this.$locale("prefecture.Kanagawa") }
          ],
        },
        {
          text: this.$locale("region.central"),
          prefecture: [
            { text: this.$locale("prefecture.Niigata") },
            { text: this.$locale("prefecture.Toyama") },
            { text: this.$locale("prefecture.Ishikawa") },
            { text: this.$locale("prefecture.Fukui") },
            { text: this.$locale("prefecture.Yamanashi") },
            { text: this.$locale("prefecture.Nagano") },
            { text: this.$locale("prefecture.Gifu") },
            { text: this.$locale("prefecture.Shizuoka") },
            { text: this.$locale("prefecture.Aichi") }
          ],
        },
        {
          text: this.$locale("region.Kinki"),
          prefecture: [
            { text: this.$locale("prefecture.Mie") },
            { text: this.$locale("prefecture.Shiga") },
            { text: this.$locale("prefecture.Kyoto") },
            { text: this.$locale("prefecture.Osaka") },
            { text: this.$locale("prefecture.Hyogo") },
            { text: this.$locale("prefecture.Nara") },
            { text: this.$locale("prefecture.Wakayama") },
          ],
        },
        {
          text: this.$locale("region.China"),
          prefecture: [
            { text: this.$locale("prefecture.Tottori") },
            { text: this.$locale("prefecture.Shimane") },
            { text: this.$locale("prefecture.Okayama") },
            { text: this.$locale("prefecture.Hiroshima") },
            { text: this.$locale("prefecture.Yamaguchi") },
          ],
        },
        {
          text: this.$locale("region.Shikoku"),
          prefecture: [
            { text: this.$locale("prefecture.Tokushima") },
            { text: this.$locale("prefecture.Kagawa") },
            { text: this.$locale("prefecture.Ehime") },
            { text: this.$locale("prefecture.Kochi") },
          ],
        },
        {
          text: this.$locale("region.KyushuOkinawa"),
          prefecture: [
            { text: this.$locale("prefecture.Fukuoka") },
            { text: this.$locale("prefecture.Saga") },
            { text: this.$locale("prefecture.Nagasaki") },
            { text: this.$locale("prefecture.Kumamoto") },
            { text: this.$locale("prefecture.Oita") },
            { text: this.$locale("prefecture.Miyazaki") },
            { text: this.$locale("prefecture.Kagoshima") },
            { text: this.$locale("prefecture.Okinawa") },
          ],
        }
      ],
      prefectureOptions: [],
    };
  },
  computed: {
    ...mapGetters("app", [
      "allAppStates",
    ]),
    ...mapState("app", {
      userName: state => state.userName,
    }),
    accountType() {
      return this.allAppStates ? this.allAppStates.adminType : localStorage.get("adminType");
    },
    isExistLoginAsAccountId() {
      return localStorage.get("loginAsAccountId");
    },
  },
  methods: {
    ...mapActions("app", [
      "setAppData",
    ]),
    choosePage(page) {
      this.onSearch = {
        ...this.onSearch,
        page: page - 1,
      };

      this.getList();
    },
    search_fn() {
      let obj = {
        ...this.onSearch,
        ...this.filter,
        page: 0,
      };

      this.onSearch = { ...obj };
      this.getList();
    },
    getRegions_fn() {
      let params = {
        page: 0,
        pageSize: 9999,
      };

      return getRegions(params, false, false);
    },
    getCinemaList_fn() {
      const that = this;
      const obj = { ...that.onSearch };

      return getCinemaList(obj, false, false);
    },
    getList() {
      const that = this;

      requestAll([that.getRegions_fn(), that.getCinemaList_fn()]).then(res => {
        let option_arr = that.formatRegionOption(res[0].data);
        let tableData = that.formatTableData(res[1].data.data, res[0].data);

        // that.pageCount = Math.ceil(res[1].data.count / that.onSearch.pageSize);
        that.pageCount = res[1].data.count || 0;
        that.tableData = tableData;
        that.regionOptions = option_arr;
      });
    },
    toDetail_fn(act = "create", id = "") {
      let url = "/cinema/create";

      if (act != "create") {
        url = "/cinema/update/" + id;
      }

      this.$router.push({ path: url });
    },
    delete_fn(index) {
      const that = this;
      const cinemaName = that.tableData[index].name;
      const cinemaId = that.tableData[index].id;
      const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${cinemaName}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        // confirm

        deleteCinema({ id: cinemaId }).then(res => {
          if (res.success) {
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                this.getList();
              }
            });
          }
        });
      });
    },
    formatTableData(list, region) {
      let tableData = [ ...list ];

      tableData.map(obj => {
        for (let i = 0; i < region.length; i++) {
          if (region[i].key == obj.region) {
            obj.regionText = region[i].value;

            for (let j = 0; j < region[i].prefectures.length; j++) {
              if (region[i].prefectures[j].key == obj.prefecture) {
                obj.prefectureText = region[i].prefectures[j].value;
                break;
              }
            }

            break;
          }
        }

        return obj;
      });

      return tableData;
    },
    formatRegionOption(obj) {
      let newOption_arr = [];

      this.regionOptions.map(regionObj => {
        for (let i = 0; i < obj.length; i++) {
          if (regionObj.text == obj[i].value) {
            let item = {
              val: obj[i].key,
              text: obj[i].value,
              prefecture: [],
            };

            regionObj.prefecture.map(text => {
              for (let j = 0; j < obj[i].prefectures.length; j++) {
                if (text.text == obj[i].prefectures[j].value) {
                  item.prefecture.push({
                    val: obj[i].prefectures[j].key,
                    text: obj[i].prefectures[j].value,
                  });
                  break;
                }
              }
            });

            newOption_arr.push(item);
            break;
          }
        }
      });

      return newOption_arr;
    },
    regionChange(val) {
      for (let i = 0; i < this.regionOptions.length; i++) {
        if (val == this.regionOptions[i].val) {
          this.prefectureOptions = [ ...this.regionOptions[i].prefecture ];
          this.filter = { ...this.filter, prefecture: "", };
          break;
        }
      }
    },
    loginAs(id) {
      loginAsCinema({ id: id }).then(res => {
        if (res.success) {
          // NOTED: NO NEED TO UPDATE TOKEN AGAIN!!
          const {
            userName,
            cinemas,
            moduleMap,
            brandId,
            permissionMap,
            type,
            id: loginAsAccountId,
            admin,
          } = res.data;
          setLocalStorage("adminType", type);
          localStorage.set("loginAsAccountId", loginAsAccountId);
          // store brand name to localStorage
          localStorage.set("brandName", this.userName);

          let userInfo = {
            userName,
            cinemas,
            cinemaId: id,
            brandId,
            moduleMap,
            permissionMap,
            adminType: type,
            isAdmin: admin,
            loginAsAccountId,
          };

          this.setAppData({ data: userInfo });
          if (this.$router.history.current.path !== "/dashboard") {
            this.$router.push("/dashboard");
          }
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
